(ns minorodata.components.sidebar.core
  (:require
   [react :as react]
   ["lucide-react" :refer [Activity AreaChart BarChart4 BarChartHorizontalBig
                           BrainCircuit
                           Cable CandlestickChart ChevronDown ClipboardListIcon CloudUpload
                           Computer Database ExternalLink FileSpreadsheet FileText
                           GitCompareArrows GitGraph Group KeyRound LayoutDashboardIcon LayoutList LineChart
                           ListChecks LogOut Map MessageSquarePlus Moon
                           ScatterChart Settings Share2 Sheet Shield
                           Sparkles SquarePlus SquareStack Sun TerminalSquare
                           ToggleLeft ToggleRight UserSquare2 UsersRound Warehouse]
    :as lucide]
   [minorodata.components.spinner.core :refer [spinner-lucide]]
   [applied-science.js-interop :as j]
   [minorodata.app.featurebase :as featurebase]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :as app.utils]
   [minorodata.components.core :as c]
   [minorodata.components.data-apps.utils :refer [acquisition-icon
                                                  agriculture-icon
                                                  customers-icon
                                                  data-apps-icon
                                                  management-icon misc-icon
                                                  products-icon
                                                  section-enabled?]]
   [minorodata.components.github-link-modal.core :as github-link-modal]
   [minorodata.components.sidebar.global-search :refer [global-search-node]]
   [minorodata.components.sql-console-modal.core :refer [toggle-console-modal]]
   ;; required for side-effect: registers :vcs.subs/user-link-status sub
   [minorodata.vcs.subs]
   [minorodata.utils :refer [contains-value]]
   [re-posh.core :as re-posh]
   [reitit.frontend.easy :as rt.easy]
   [ui.button :refer [button]]
   [ui.dropdown-menu :refer [dropdown-menu-content dropdown-menu-item
                             dropdown-menu-root dropdown-menu-trigger]]
   [ui.navigation :as ui-nav]
   [ui.tooltip :refer [tooltip]]
   [ui.utils :refer [clsx]]))

(def menu-list
  [{:name       "Overview"
    :icon       LayoutDashboardIcon
    :data-cy    :add-new-source-section
    :link-route :overview
    :routes     #{:overview}
    :feature-flag "fe.dashboard"}
   {:title "Ingest"
    :links [{:name       "Add new source"
             :icon       SquarePlus
             :data-cy    :add-new-source-section
             :link-route :sources
             :routes     #{:sources}}
            {:name       "Sources"
             :icon       Cable
             :data-cy    :sources-section
             :link-route :extracts
             :routes     #{:extracts :source-details :extract-details}}
            {:name       "File ingest"
             :icon       CloudUpload
             :data-cy    :file-ingest-section
             :link-route :file-ingest
             :routes     #{:file-ingest}}
            {:name         "Webforms"
             :icon         FileSpreadsheet
             :data-cy      :webforms-section
             :link-route   :webforms
             :routes       #{:webforms :webforms-table}
             :feature-flag [[:app.subs/enabled-for-bigquery :webforms]]}]}
   {:title "Model"
    :links [{:name                 "Tables"
             :icon                 Sheet
             :data-cy              :tables-section
             :routes               #{:tables :table-details}
             :link-route           :tables
             :feature-flag         [[:app.subs/enabled-for-bigquery :tables]]}

            {:name         "Transforms"
             :icon         LayoutList
             :data-cy      :transformations-section
             :link-route   :transformations
             :routes       #{:transformations :new-group-form :transforms :new-transform-form :group-details :transform-details}
             :feature-flag [[:app.subs/enabled-for-bigquery :transforms]]}

            {:name         "Pipelines"
             :icon         Share2
             :data-cy      :dag-section
             :link-route   :dag
             :routes       #{:dag}
             :feature-flag [[:app.subs/enabled-for-bigquery :dag]]}

            {:name         "SQL console"
             :title        "CMD-K or CTRL-K"
             :icon         TerminalSquare
             :data-cy      :sql-console-modal-section
             :permissions  #{:sql-browser/read}
             :feature-flag [[:app.subs/enabled-for-bigquery :sql-console-modal]]
             :on-click     toggle-console-modal}
            {:name         "Data docs"
             :icon         FileText
             :data-cy      :dynamic-docs-section
             :link-route   :dynamic-docs
             :routes       #{:dynamic-docs :dynamic-docs-details}
             :feature-flag [[:app.subs/enabled-for-bigquery :dynamic-docs]]}
            {:name         "Pipeline editor"
             :icon         GitGraph
             :data-cy      :pipeline-editor-section
             :link-route   :pipeline-editor
             :routes       #{:pipeline-editor}
             :permissions  #{:pipeline-editor/read}
             :feature-flag "fe.pipeline-editor"}
            {:name         "Analytics models"
             :icon         BrainCircuit
             :data-cy      :analytics-models-section
             :link-route   :analytics-models
             :routes       #{:analytics-models :analytics-model-instance-details :analytics-model-create}
             :permissions  #{:analytics-models/read}
             :feature-flag "fe.analytics-models"}]}

   {:title "Insights"
    :links [{:name         "Share data"
             :icon         Group
             :data-cy      :data-views-section
             :link-route   :data-views
             :routes       #{:data-views :data-view-details}
             :feature-flag [[:app.subs/enabled-for-bigquery :data-views]]}]}

   {:title "Manage"
    :links [{:name       "Logs"
             :icon       ListChecks
             :data-cy    :log-section
             :link-route :log
             :routes     #{:log}}
            {:name       "Audit logs"
             :icon       ClipboardListIcon
             :data-cy    :audit-logs
             :link-route :audit-logs
             :routes     #{:audit-logs}
             :feature-flag "fe.audit-logs"}
            {:name       "Transform queue"
             :icon       SquareStack
             :data-cy    :transform-queue
             :link-route :transform-queue
             :routes     #{:transform-queue}
             :feature-flag "fe.transforms-queue"}
            {:name         "Warehouse usage"
             :icon         Warehouse
             :data-cy      :warehouse-usage-section
             :link-route   :warehouse-usage
             :routes       #{:warehouse-usage}
             :feature-flag ["cost-section"
                            [:app.subs/enabled-for-bigquery :costs]]}
            {:name   "Kleene docs"
             :icon   ExternalLink
             :href   "https://docs.kleene.ai/docs"
             :target "_blank"}]}])

(defn data-apps-menu-list [& [get-all?]]
  (let [customer-dashboards (->> @(re-posh/subscribe [:data-app/pull-many])
                                 (map :data-app/data-app-id)
                                 (mapv #(if (= % "workbook") :data-apps-workbook (keyword %)))
                                 set)]
    (->>
     [{:title      "Browse apps"
       :link-route :data-apps
       :icon       data-apps-icon}
      {:title "My apps"}
      {:title "Acquisition"
       :icon  acquisition-icon
       :disabled-flags ["fe.data-apps-agriculture"]
       :links [{:name       "Market view"
                :icon       UserSquare2
                :link-route :data-apps-acquisition-market-view}
               {:name       "Audiences"
                :icon       Share2
                :link-route :data-apps-acquisition-audience-ai}
               {:name       "Spend"
                :icon       BarChartHorizontalBig
                :link-route :data-apps-acquisition-spend-optimisation}]}
      {:title "Products"
       :icon  products-icon
       :disabled-flags ["fe.data-apps-agriculture"]
       :links [{:name       "Product view"
                :icon       AreaChart
                :link-route :data-apps-products-product-view}
               {:name       "Demand"
                :icon       ScatterChart
                :link-route :data-apps-products-demand}
               {:name       "Inventory"
                :icon       LineChart
                :link-route :data-apps-products-inventory}]}
      {:title "Customers"
       :icon  customers-icon
       :disabled-flags ["fe.data-apps-agriculture"]
       :links [{:name       "Customer view"
                :icon       UsersRound
                :link-route :data-apps-customers-customer-view}
               {:name       "Segmentation"
                :icon       LayoutList
                :link-route :data-apps-customers-ai-segmentation}
               {:name       "Churn prediction"
                :icon       Activity
                :link-route :data-apps-customers-churn-prediction}]}
      {:title "Management"
       :icon  management-icon
       :disabled-flags ["fe.data-apps-agriculture"]
       :links [{:name       "Scorecard"
                :icon       CandlestickChart
                :link-route :data-apps-management-scorecard}
               {:name       "Sales"
                :icon       BarChart4
                :link-route :data-apps-management-sales}
               {:name       "Hubspot"
                :icon       Computer
                :link-route :data-apps-management-hubspot}]}
      {:title  "Agriculture"
       :icon   agriculture-icon
       :enabled-flags ["fe.data-apps-agriculture"]
       :links [{:name       "Futures Open Position"
                :icon       UsersRound
                :link-route :data-apps-agriculture-futures}
               {:name       "Contracts Overview"
                :icon       LayoutList
                :link-route :data-apps-agriculture-contracts-overview}
               {:name       "Market Analysis & Scenario Planning"
                :icon       Activity
                :link-route :data-apps-agriculture-market-analysis}
               {:name       "Physicals Trading Analysis"
                :icon       BarChart4
                :link-route :data-apps-agriculture-trading-analysis}]}
      (when (or get-all?
                @(re-posh/subscribe [:unleash/is-enabled "sigma-self-serve"]))
        {:title "Miscellaneous"
         :icon  misc-icon
         :links [{:name       "My reports"
                  :icon       LineChart
                  :link-route :data-apps-workbook}]})]
     (mapv (fn [section]
             (if (and (not get-all?) (:links section))
               (when-let [links (seq (filter #(customer-dashboards (:link-route %))
                                             (:links section)))]
                 (assoc section :links links))
               section)))
     (filter identity))))


(defn toggle-dark-mode []
  (dispatch [:app.events/toggle-dark-mode]))


(defn read-feature-flags [feature-flag]
  (cond (string? feature-flag)
        @(re-posh/subscribe [:unleash/is-enabled feature-flag])

        (vector? feature-flag)
        (->> feature-flag
             (map (fn [flag]
                    (if (string? flag)
                      @(re-posh/subscribe [:unleash/is-enabled flag])
                      @(re-posh/subscribe flag))))
             (every? true?))))


(defn- enrich-single-link [route {:keys [link-route routes feature-flag invert-feature-flag? permissions] :as link} extra-data]
  (let [enabled?          (if feature-flag
                            (read-feature-flags feature-flag)
                            true)
        enabled?          (if (some? invert-feature-flag?)
                            (and enabled? (not (read-feature-flags invert-feature-flag?)))
                            enabled?)
        route-permissions (or (:permissions (c/screen-components {:route-name link-route}))
                              permissions)
        has-permission?   @(re-posh/subscribe [:users.subs/has-permissions? route-permissions])]
    (when enabled?
      (-> link
          (app.utils/assoc-some
           :href (some-> link-route rt.easy/href)
           :disabled (not has-permission?)
           :active? (contains? routes route))
          (merge (get extra-data link-route))))))

(defn- enrich-links [route links extra-data]
  (into [] (keep #(enrich-single-link route % extra-data) links)))

(defn enrich-section [route {:keys [links]} {:keys [title] :as section} extra-data]
  (let [single-item? (not (contains? section :links))
        section (if single-item?
                  (enrich-single-link route section extra-data)
                  (-> section
                      (assoc :initial-expand (get links (keyword title) true))
                      (update :links #(enrich-links route % extra-data))))]
    (when (or single-item? (not-empty (:links section)))
      section)))

(defn- enrich-menu-links [link-sections route config extra-data]
  (into [] (keep #(enrich-section route config % extra-data) link-sections)))

(defn user-dropdown-items []
  (let [{:user/keys [uid]} @(re-posh/subscribe [:user/pull])
        dark-mode?               @(re-posh/subscribe [:app/prop :app/dark-mode?])
        creds                    @(re-posh/subscribe
                                   [:warehouse-credentials/pull
                                    [:warehouse-credentials/user-id uid]])
        user-wh-credentials?    (:warehouse-credentials/enforce-credentials creds)
        admin?                   @(re-posh/subscribe [:users.subs/admin?])
        super-admin?             @(re-posh/subscribe [:users.subs/superadmin?])
        gh-status                @(re-posh/subscribe [:vcs.subs/user-link-status])
        gh-flag?                 @(re-posh/subscribe [:unleash/is-enabled "fe.git-full-sync"])
        gh-enabled?              (and gh-flag? (:vcs-user-link/github-enabled gh-status))
        gh-connected?            (:vcs-user-link/connected gh-status)
        gh-login                 (:vcs-user-link/login gh-status)
        ;; indicator-A label: connected -> "GitHub: @<login>", else "Link GitHub".
        gh-label                 (cond
                                   (and gh-connected? gh-login) (str "GitHub: @" gh-login)
                                   gh-connected?                "GitHub"
                                   :else                        "Link GitHub")]

    (filter
     identity
     [(when (or admin? super-admin?)
        {:name "App Settings"
         :icon Settings
         :href (rt.easy/href :admin)})
      (when gh-enabled?
        {:name     gh-label
         :icon     GitCompareArrows
         :on-click github-link-modal/open-github-link-modal})
      (when super-admin?
        {:name "App Admin"
         :icon Shield
         :href (rt.easy/href :app-admin)})
      (when user-wh-credentials?
        {:name "Warehouse credentials"
         :icon KeyRound
         :href (rt.easy/href :warehouse-credentials)})
      {:name      "What's new"
       :icon      Sparkles
       :on-click  featurebase/open-changelog!
       :unviewed? (featurebase/changelog-unviewed?)}
      {:name "Feature request"
       :icon MessageSquarePlus
       :href (rt.easy/href :feature-request)}
      {:name   "Roadmap"
       :icon   Map
       :href   "https://kleene.ai/roadmap"
       :target "_blank"}
      {:name "Privacy policy"
       :icon ExternalLink
       :href (rt.easy/href :privacy-policy)
       :target "_blank"}
      {:name     (if dark-mode? "Light theme" "Dark theme")
       :icon     (if dark-mode? Sun Moon)
       :on-click toggle-dark-mode}
      {:name     "Log out"
       :icon     LogOut
       :on-click #(dispatch [:users.events/logout])}])))

(defn- unviewed-dot [{:keys [class]}]
  [:span {:aria-hidden true
          :class       (clsx "pointer-events-none size-2 shrink-0 rounded-full bg-kleene-secondary-v2" class)}])

(defn user-menu []
  (let [{:user/keys [uid roles]
         email :user/user} @(re-posh/subscribe [:user/pull])]

    (when-not (contains-value roles "restricted")
      (dispatch [:users.api/fetch-warehouse-credentials {:user-id uid}]))

    (fn []
      [dropdown-menu-root
       [dropdown-menu-trigger {:class "relative radix-state-open:[&_svg]:rotate-180"}
        [button {:component  :div
                 :title      email
                 :size       :small
                 :variant    :secondary
                 :full-width true
                 :icon-right ChevronDown
                 :class      "py-2"
                 :icon-right-props {:size 20 :class "transition-transform"}}
         [:span {:class "truncate"} email]]
        (when (featurebase/changelog-unviewed?)
          [unviewed-dot {:class "absolute top-1 right-1"}])]

       [dropdown-menu-content
        (for [{:keys [name icon href target on-click unviewed?]} (user-dropdown-items)]
          (let [tag (if href :a :div)]
            ^{:key name}
            [dropdown-menu-item {:class "p-0"}
             [tag {:href     href
                   :target   target
                   :on-click on-click
                   :class    "flex gap-2 font-medium px-2 py-1.5"}
              (when icon [:> icon {:size 20}])
              name
              (when unviewed?
                [unviewed-dot {:class "self-center"}])]]))]])))

(defn get-next-mode [mode]
  (if (= mode "app") "data-apps" "app"))

(defn change-app-mode [current-mode next-mode]
  (let [user             (js->clj (js/JSON.parse (js/localStorage.getItem "minorodata-user"))
                                  :keywordize-keys true)
        client-id        (:cid user)
        set-storage-key  (str "last-visit-page-" client-id "-" current-mode)
        get-storage-key  (str "last-visit-page-" client-id "-" next-mode)
        last-route       (some-> (j/call js/localStorage :getItem get-storage-key)
                                 js/JSON.parse (js->clj :keywordize-keys true))
        default-route    (if (= next-mode "app")
                           [:sources]
                           [:data-apps])

        {:app-route/keys [name params]}
        @(re-posh/subscribe [:app-route/pull])]

    (j/call js/localStorage :setItem set-storage-key (-> [name params] clj->js js/JSON.stringify))

    (let [[name params] (or last-route default-route)]
      (dispatch [:app.events/navigate (keyword name) params]))))

(def mode-buttons
  {"app"       {:children   "Data setup"
                :icon       BarChartHorizontalBig
                :icon-right ToggleLeft}
   "data-apps" {:children   "Data apps"
                :icon       Database
                :icon-right ToggleRight}})

(defn switch-context-menu [{:keys [mode]}]
  (let [next-mode (get-next-mode mode)]
    [button
     (merge (get mode-buttons next-mode)
            {:variant  :secondary
             :size     :small
             :on-click #(change-app-mode mode next-mode)
             :icon-props {:size 20 :class "-my-0.5"}
             :icon-right-props {:size 20 :class "-my-0.5"}})]))

(defn app-menu [{:keys [mode]}]
  [:div {:class "flex flex-col gap-1 items-stretch"}
   (when @(re-posh/subscribe [:unleash/is-enabled "fe.data-apps"])
     [switch-context-menu {:mode mode}])
   [user-menu]])


(defn failed-extract [{:keys [extract-id]}]
  (let [{:extract/keys [source-id extract-id name]} @(re-posh/subscribe [:extract/pull [:extract/extract-id extract-id]])
        route (rt.easy/href :extract-details {:extract-id extract-id :source-id source-id})
        logs-route (rt.easy/href :log {} {:term name})]
    [:div {:class ["flex flex-row border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03"
                   "transition-colors hover:bg-kleene-neutral-05 dark:hover:bg-kleene-dark-03"
                   "p-1 text-xs"]}
     [:a {:class "inline-block whitespace-nowrap w-full grow max-w-[400px] text-ellipsis overflow-hidden"
          :title "Open extract"
          :href route}
      name]
     [:span {:class "text-kleene-dark-04 dark:text-kleene-dark-0 text-xs w-4 grow-0 shrink-0 ml-4"}
      [:a {:href logs-route
           :title "Open in logs"}
       [:> ListChecks {:size 16
                       :class "cursor-pointer hover:text-kleene-secondary-v2 transition-colors"}]]]]))

(defn extract-count-tooltip [{:keys [statuses count-today]}]
  (let [loading? @(re-posh/subscribe [:mold-http/loading? :connections.api/fetch-extract])]
    [:div {:class "pb-2"}
     [:div {:class "flex flex-row border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03 pb-4 pt-2"}
      [:div {:class ["text-kleene-dark-04 dark:text-kleene-dark-0"]}
       "Extracts failed today: "
       [:b {:class "ml-2"} count-today]]]

     (if loading?
       [:div {:class "w-full h-full flex items-center justify-center gap-2 mt-4"}
        [spinner-lucide] "Loading..."]

       (for [status statuses]
         [:f> failed-extract status]))]))

(defn failed-extracts-count-comp []
  (let [failed-extracts-count       (count @(re-posh/subscribe [:statuses.subs/failed-today :extract]))
        failed-extracts-count-total (count @(re-posh/subscribe [:statuses.subs/failed :extract]))

        failed-extracts @(re-posh/subscribe [:statuses.subs/failed-today :extract])]

    (react/useEffect
     (fn []
       (doall
        (for [failure failed-extracts]
          (dispatch [:connections.api/fetch-extract
                     {:extract-id (:extract-id failure)
                      :source-id (:source-id failure)
                      :on-success (fn [])}])))

       ;; return unsubscribe callback
       (fn []))
     #js [failed-extracts])

    (when (not= 0 failed-extracts-count)
      [tooltip {:trigger-as-child true
                :class "min-w-[200px] w-full max-w-[500px]"
                :content-props {:side "right"}
                :content [:f> extract-count-tooltip
                          {:statuses    failed-extracts
                           :count-today failed-extracts-count
                           :count-total failed-extracts-count-total}]}
       [:span {:class "bg-kleene-text-error/30 text-kleene-text-error px-1 shrink-0 h-5 flex items-center justify-center rounded"}
        failed-extracts-count]])))

(defn failed-transform [{:keys [transform-id group-id]}]
  (let [{:transform/keys [name]} @(re-posh/subscribe [:transform/pull [:transform/id transform-id]])
        route (rt.easy/href :transforms {:group-id group-id})
        logs-route (rt.easy/href :log {} {:source "job-manager"
                                          :term name})]
    [:div {:class ["flex flex-row border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03"
                   "transition-colors hover:bg-kleene-neutral-05 dark:hover:bg-kleene-dark-03"
                   "p-1 text-xs"]}
     [:a {:class "inline-block whitespace-nowrap w-full grow max-w-[400px] text-ellipsis overflow-hidden"
          :title "Open transform's group"
          :href route}
      name]
     [:span {:class "text-kleene-dark-04 dark:text-kleene-dark-0 text-xs w-4 grow-0 shrink-0 ml-4"}
      [:a {:href logs-route
           :title "Open in logs"}
       [:> ListChecks {:size 16
                       :class "cursor-pointer hover:text-kleene-secondary-v2 transition-colors"}]]]]))

(defn transform-count-tooltip [{:keys [statuses count-today]}]
  (let [loading? @(re-posh/subscribe [:mold-http/loading? :transform.api/fetch-single-transform])]
    [:div {:class "pb-2"}
     [:div {:class "flex flex-row border-solid border-0 border-b border-kleene-neutral-05 dark:border-kleene-dark-03 pb-4 pt-2"}
      [:div {:class ["text-kleene-dark-04 dark:text-kleene-dark-0"]}
       "Transforms failed today: "
       [:b {:class "ml-2"} count-today]]]

     (if loading?
       [:div {:class "w-full h-full flex items-center justify-center gap-2 mt-4"}
        [spinner-lucide] "Loading..."]
       (for [status statuses]
         [:f> failed-transform status]))]))

(defn failed-transforms-count-comp []
  (let [failed-transforms-count       @(re-posh/subscribe [:transform.subs/failed-statuses-count-today])
        failed-transforms-count-total @(re-posh/subscribe [:transform.subs/failed-statuses-count])

        failed-transforms @(re-posh/subscribe [:transform.subs/failed-statuses-today])]

    (react/useEffect
     (fn []
       (doall
        (for [failure failed-transforms]
          (dispatch [:transform.api/fetch-single-transform
                     {:transform-id (:transform-id failure)
                      :group-id (:group-id failure)
                      :add-to-panel? false
                      :on-finish (fn [])}])))

       ;; return unsubscribe callback
       (fn []))
     #js [failed-transforms])

    (when (not= 0 failed-transforms-count)
      [tooltip {:trigger-as-child true
                :class "min-w-[200px] w-full max-w-[500px]"
                :content-props {:side "right"}
                :content [:f> transform-count-tooltip
                          {:statuses    failed-transforms
                           :count-today failed-transforms-count
                           :count-total failed-transforms-count-total}]}
       [:span {:class "bg-kleene-text-error/30 text-kleene-text-error px-1 shrink-0 h-5 flex items-center justify-center rounded"}
        failed-transforms-count]])))

(defn app-sidebar []
  (dispatch [:connections.api/fetch-transform-statuses])
  (dispatch [:connections.api/fetch-extract-statuses {:status "fail"}])
  ;; self-scoped GitHub link status; drives the user drop-up GitHub entry.
  ;; Only fetch when the VCS feature flag is on (avoids a needless call/toast
  ;; for clients without git sync).
  (when @(re-posh/subscribe [:unleash/is-enabled "fe.git-full-sync"])
    (dispatch [:vcs.api/get-user-link-status]))

  (fn [{:keys [sidebar-enabled route]}]
    (let [config                  @(re-posh/subscribe [:app/prop :app/navbar])
          new-pages               @(re-posh/subscribe [:app.subs/new-page-labels])

          mode     (:mode config)
          items    menu-list

          sections (when sidebar-enabled
                     (enrich-menu-links items route config
                                        (merge
                                         (when @(re-posh/subscribe [:unleash/is-enabled "fe.sidebar-failures-count"])
                                           {:extracts {:label failed-extracts-count-comp}
                                            :transformations {:label failed-transforms-count-comp}})
                                         (when (not-empty new-pages)
                                           (reduce (fn [acc page] (assoc acc page {:new? true})) {} new-pages)))))
          visible  (or (not @(re-posh/subscribe [:unleash/is-enabled "fe.data-apps"]))
                       (not mode)
                       (= mode "app"))

          context @(re-posh/subscribe [:unleash/get-context])

          on-expand         (fn [expanded?]
                              (dispatch [:app.events/update-navbar {:initial-expand expanded?}]))
          on-section-expand (fn [section expanded?]
                              (dispatch [:app.events/update-navbar {:links {(:title section) expanded?}}]))]

      [ui-nav/sidebar {:class          (clsx "dark"
                                             {"-translate-x-full z-0 absolute left-0 top-0" (not visible)})
                       :loading?       (nil? (:warehouse-type context))
                       :post-nav       [app-menu {:mode mode}]
                       :initial-expand (if (contains? config :initial-expand) (:initial-expand config) true)
                       :on-expand      on-expand}
       [:<>
        (when @(re-posh/subscribe [:unleash/is-enabled "fe.global-search"])
          ;; sticky so scrolling the sidebar keeps the trigger (and its anchored
          ;; popover) pinned at the top; bg matches the sidebar to mask content
          ;; scrolling underneath
          [ui-nav/menu-section {:class "sticky top-0 z-30 dark:bg-kleene-background py-0 -mt-2 pt-2"}
           [:f> global-search-node]])
        [ui-nav/expandable-sections-list {:sections sections
                                          :on-expand on-section-expand}]]])))


(defn data-apps-sidebar [{:keys [route]}]
  (let [config   @(re-posh/subscribe [:app/prop :app/navbar])
        mode     (:mode config)
        visible  (= (:mode config) "data-apps")

        on-expand (fn [expanded?]
                    (dispatch [:app.events/update-navbar {:initial-expand expanded?}]))

        enabled-data-apps-menu-list (filterv section-enabled? (data-apps-menu-list))]

    [ui-nav/sidebar {:class          (clsx {"-translate-x-full z-0 absolute left-0 top-0" (not visible)})
                     :bg-class       "dark:bg-kleene-dark-02"
                     :post-nav       [app-menu {:mode mode}]
                     :initial-expand (if (contains? config :initial-expand) (:initial-expand config) true)
                     :logo-props     {:href (rt.easy/href :data-apps)}
                     :on-expand      on-expand}
     [:div {:class "flex flex-col gap-2 px-1"}
      (for [{:keys [title link-route routes icon links]} enabled-data-apps-menu-list]
        (let [routes (some->> link-route (conj routes) set)
              tag (if link-route :a :div)]
          ^{:key title}
          [:div
           [tag {:class (clsx "flex gap-2 items-center font-medium px-2 py-1 rounded-xs"
                              {"bg-kleene-neutral-02 dark:bg-kleene-selected-background" (and routes (contains? routes route))
                               "font-bold" (not icon)})
                 :href (some-> link-route rt.easy/href)}
            (when icon [icon])
            title]

           (when (seq links)
             [:div
              (for [{:keys [name icon on-click link-route]} links
                    :let [active? (= link-route route)
                          href    (some-> link-route rt.easy/href)]]
                ^{:key name}
                [ui-nav/menu-link {:icon icon :name name :on-click on-click :href href :active? active?}])])]))]]))

(defn sidebar [{:keys [route sidebar-enabled]}]
  (let [ready?        @(re-posh/subscribe [:app.subs/app-ready?])
        current-route (keyword route)]

    (when ready?
      [:<>
       [app-sidebar
        {:route              current-route
         :sidebar-enabled    sidebar-enabled}]
       (when @(re-posh/subscribe [:unleash/is-enabled "fe.data-apps"])
         [data-apps-sidebar
          {:route           current-route
           :sidebar-enabled sidebar-enabled}])
       ;; single instance (mounted only when logged in / app ready); the user
       ;; drop-up entry toggles it open via github-link-modal/open-github-link-modal
       [:f> github-link-modal/github-link-modal]])))
